<template>
  <b-container class="mt-4">
    <div class="d-flex justify-content-start align-items-center">
      <b-link class="mr-3 h1 mt-2" @click="$router.back()"
        ><i class="ri-arrow-left-s-line"></i
      ></b-link>
      <img
        :src="require('@/assets/img/brand/favicon.png')"
        width="60px"
        alt="logo"
      />
      <span class="h1 display-5"> {{ $t("conditions") }} </span>
    </div>
    <hr />
    <vue-marked>{{ terms ? terms.content : "" }}</vue-marked>
  </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VueMarked from "vue-marked";
export default {
  components: {
    VueMarked,
  },
  async created() {
    await this.getTerms({ language: localStorage.getItem("lang") });
  },
  methods: {
    ...mapActions({
      getTerms: "conditions/getTerms",
    }),
  },
  computed: {
    ...mapGetters({
      terms: "conditions/terms",
    }),
  },
};
</script>
<style>
pre code {
  color: chocolate !important;
}
</style>